import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../client-api';
import type { ClientTalkingPointCreateDto, ClientTalkingPointDto } from '../../generated/client';
import { createClientTalkingPointRelation } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const usePinTalkingPoint = (): UseMutationResult<ClientTalkingPointDto, AxiosError, ClientTalkingPointCreateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.client(client?.partnerUuid), [client?.partnerUuid]);

    return useMutation({
        mutationFn: (payload: ClientTalkingPointCreateDto) =>
            createClientTalkingPointRelation({
                body: {
                    clientId: payload.clientId,
                    talkingPointId: payload.talkingPointId,
                    topicId: payload.topicId,
                },
            }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey });
        },
    });
};
